/**
 * analytics — best-effort GA4 / GTM event push.
 *
 * The app loads GTM (GTM-MVVDKZ3R) in client/public/index.html. GTM owns the
 * GA4 measurement tag (Property G-75QMEGCWCF) and any other downstream pixels.
 * From the app we only push events into the dataLayer; GTM decides what fires
 * from each event.
 *
 * Cross-domain measurement: the marketing site (iprotectyou.family) and this
 * app (app.iprotectyou.family) share the same GA4 property. The data stream's
 * "Configure your domains" lists both — that's what stitches a WordPress
 * landing-page visit and an app conversion into one session.
 *
 * Always best-effort and silent. A blocked tracker or a missing dataLayer must
 * never break a quote or booking submit.
 */

export function pushEvent(event, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    // intentionally silent — analytics failure never breaks a flow
  }
}
